import { FilterBar, FormGroup, Label, Select } from '@celltrak/ui-components';

import usePayersFilterBar from './hooks';

function PayersFilterBar() {
  const { aggregatorOptions, showResetButton, handleFilterChanges, handleResetFilter, filters } =
    usePayersFilterBar();

  return (
    <FilterBar
      onPrimaryClick={() => handleResetFilter()}
      buttonSize="sm"
      showPrimaryButton={showResetButton}
      showSecondaryButton={false}
      primaryButtonLabel="Reset"
    >
      <FormGroup>
        <Label for="aggregator-filter" size="sm">
          Aggregators
        </Label>
        <Select
          id="aggregator-filter"
          size="sm"
          options={aggregatorOptions}
          value={filters.aggregatorID}
          onChange={handleFilterChanges('aggregatorID')}
        />
      </FormGroup>
    </FilterBar>
  );
}

export default PayersFilterBar;
